import axios from 'axios'

import {api_url} from "../config/site";

import { RSADecrypt,RSAEncrypt,verify,REAsign } from "../utils/rsa";
import { AESDecrypt,AESEncrypt } from "../utils/aes";

// 解密Rsa
/**
 * rsa解密第一步解密left
 * @param {*} response 响应体
 * @param {*} responseObject 解析后的存放的对象
 * 
 * 解析后的结果是16位随机字符串
 * 字符串是aes解析middle内容的密钥
 */
function RSADecryptRequest(response,responseObject) {
  let left = RSADecrypt(response.left)
  responseObject.left = left
  AESDecryptRequest(left,response,responseObject)
};
/**
 * 解密第二步:解密middle
 * @param {*} left 密钥
 * @param {*} response 响应体
 * @param {*} responseObject 解析后的存放的对象
 * 
 * 解析后的结果是响应体的内容
 */
function AESDecryptRequest(left,response,responseObject) {
  let data = AESDecrypt(left,response.middle)
  responseObject.middle=JSON.parse(data)
  yanqianRequest(data,response,responseObject) 
};
/**
 * 解密第三部验签
 * @param {*} middle 验签的内容
 * @param {*} response 响应体
 * @param {*} responseObject 解析后的存放的对象
 * 
 * 结果是个布尔值,是否验签通过
 */
function yanqianRequest(middle,response,responseObject) {
  responseObject.right= verify(middle,response.right)
};
/**
 * 加密第一步
 * 
 * @param {*} data 要加密的内容
 * @param {*} requestObject 加密的结果存放的对象
 * 
 * 结果返回个对象 加密的内容, 加密的16位随机字符串
 */
function AESEncryptRequest(data,requestObject) {
  let object = AESEncrypt(data)
  requestObject.middle = object.data
  let key = object.key
  RSAEncryptRequest(key,requestObject)
  REAsignRequest(data,requestObject)
};
/**
 * 加密第二步 加密加密的16位随机字符串
 * @param {*} key 要加密的16位随机字符串
 * @param {*} requestObject 加密的结果存放的对象
 */
function RSAEncryptRequest(key,requestObject) {
  requestObject.left = RSAEncrypt(key)
};
/**
 * 加密第三部 加签
 * @param {*} requestObject 
 */
function REAsignRequest(data,requestObject) {
  requestObject.right = REAsign(data)
}


const instance = axios.create({
    baseURL: api_url,
});


//获取url里的参数，接受一个参数名作为参数
function getQueryVariable(variable) {
  //获取当前URL中的查询字符串部分（即问号后面的部分）
  var query = window.location.search.substring(1);
  //把查询字符串按照&符号分割成数组
  var vars = query.split("&");
  //遍历数组中的每个元素
  for (var i = 0; i < vars.length; i++) {
    //把当前元素按照=符号分割成键和值
    var pair = vars[i].split("=");
    //如果当前元素的键等于参数名，则返回对应的值
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  //如果没有找到匹配的参数名，则返回false
  return false;
}

instance.interceptors.request.use(function (config) {
  var map = config.data
  let requestObject= {}
 // console.log('请求的参数',map);
  AESEncryptRequest(map,requestObject)
  config.data= requestObject
  // 是否是灰度线上环境
  let environmentUrl = window.location.href.indexOf('croaker.xiaomaiyuyin.com') != -1
    if(environmentUrl) {
        config.headers.Tenant_Id = "green"
    }
  /*用户登录标识*/
  config.headers.authorization = sessionStorage.getItem('token') ? 'Bearer ' + sessionStorage.getItem('token') : '';
  config.headers.os = 'h5'
  config.headers.openId = getQueryVariable('openId')
 // console.log(window);
  return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    let responseObject = {}
    let map = response.data
    RSADecryptRequest(map,responseObject)
    console.log('解密后的结果',responseObject);
    if (responseObject.right) {
      return responseObject.middle
    } else {
      return {
        code: -10034,
        msg: "响应验证失败",
        data: {}
      }
    }
}, function (error) {
    return Promise.reject(error);
});

export default instance;
